<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Non-Moving Inventory Report</h4>
      </el-col>
    </el-row>
    <el-table :data="list.data">
      <el-table-column label="Part No." prop="part_no"></el-table-column>
      <el-table-column label="Description" prop="description"></el-table-column
      ><el-table-column label="Location" prop="location"></el-table-column>
      <el-table-column label="Batch No." prop="batch_no"></el-table-column>
      <el-table-column label="Supplier" prop="supplier"></el-table-column>
      <el-table-column label="Remaining Quantity" prop="remaining_quantity">
        <template slot-scope="scope">
          {{ scope.row.remaining_quantity | number("0,0") }}
        </template>
      </el-table-column>
      <el-table-column label="Item Type" prop="item_type"></el-table-column>
      <el-table-column label="Final Price (AED)" prop="final_price_aed">
        <template slot-scope="scope">
          {{ scope.row.final_price_aed | currency("AED ") }}
        </template>
      </el-table-column>
    </el-table>
    <el-row
      :gutters="15"
      type="flex"
      align="middle"
      v-show="list.data.length > 0"
    >
      <el-col :sm="12">
        <el-pagination
          v-show="!is_loading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="search"
        ></el-pagination>
      </el-col>
      <el-col :sm="12" class="text-right">
        <!-- <a v-show="pager.supplier_id" :href="baseUrl"></a> -->
        <el-button type="primary" size="small" @click="download"
          >Download Report</el-button
        >
      </el-col>
    </el-row>
    <div>
      <el-button type="primary" size="small" @click="download">Download Report</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
export default {
  name: "nonmoving",

  data() {
    return {
      is_loading: false,
      list: { data: [], paging: {} },
      pager: {
        page: 1,
        limit: 25
      }
    };
  },
  methods: {
    search(page) {
      let url = `api/v1/inventory/non_moving/`;
      this.is_loading = true;
      let params = {
        page: page ? page : this.pager.page,
        limit: this.pager.limit
      };
      api.get(url, params).then(resp => {
        if (resp) this.list = resp.data;
        this.is_loading = false;
      });
    },
    download() {
        let d = moment().format("MM-DD-YYYY");
        let reportInfo = {
          name: `Non Moving Report ${d}`,
          ext: ".csv"
        };
        this.isLoading = true;
        let url = `/api/v1/inventory/non_moving/?is_download=1`;
        api.download(url, reportInfo).then(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    // this.search();
  }
};
</script>

<style lang="css" scoped></style>
